import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
  title: {
    alignSelf: 'center',
  },
  header: {
    marginTop: 12,
    alignItems: 'center',
    marginHorizontal: 0,
  },
  question: {
    fontSize: 25,
    marginTop: 20,
  },
  contentText: {
    marginTop: 40,
    fontSize: 17,
    lineHeight: 24,
  },
  button: {
    marginTop: 60,
  },
});
export default style;
